import React from "react";
import {Button} from "reactstrap";
import {PencilIcon, TrashIcon} from "./icons";

/** Edit/remove icon buttons for a list row. `noun` completes the labels ("item"). */
const RowActions = ({noun, onEdit, onRemove}) => (
    <>
        <Button color="link" className="px-2" aria-label={`Editar ${noun}`} title={`Editar ${noun}`} onClick={onEdit}>
            <PencilIcon />
        </Button>
        <Button
            color="link"
            className="text-danger px-2"
            aria-label={`Remover ${noun}`}
            title={`Remover ${noun}`}
            onClick={onRemove}
        >
            <TrashIcon />
        </Button>
    </>
);

export default RowActions;
